import { NgOptimizedImage } from "@angular/common";
import { Component, input, model } from "@angular/core";
import { DirectusTranslationPipe } from "../../../../../../common/pipes/directus-translation.pipe";
import { GetDirectusImagePipe } from "../../../../../../common/pipes/get-directus-image.pipe";
import { ItemsProductCategories } from "../../../../../api/packbo/models/items-product-categories";

@Component({
    selector: "packbo-subcategory-card",
    templateUrl: "./subcategory-card.template.html",
    imports: [NgOptimizedImage, GetDirectusImagePipe, DirectusTranslationPipe]
})
export class SubcategoryCardComponent {
    public readonly subcategory = input.required<ItemsProductCategories>();
    public readonly selectedSubcategoryId = model<number | null>(null);

    public getSuppliersBySubcategory(subcategoryId: number | undefined): void {
        if (!subcategoryId) {
            return;
        }

        this.selectedSubcategoryId.set(subcategoryId);
    }
}
